const ReviewDeckColors = {
  blue: ['#00b8db', '#00c8e4', '#7bdef0'],
  green: ['#23b975', '#23cc7f', '#ffffff61'],
  orange: ['#f78139', '#fb9152', '#ffffff61'],
  purple: ['#9873E6', '#a687ec', '#ffffff61'],
  gray: ['#5b5b5b', '#7b7b7b', '#ffffff61'],
  black: ['#000', '#3c3c3c', '#ffffff61'],
  red: ['#FF5252', '#ff7373', '#ffffff61'],
  pink: ['#F886C1', '#fd9cce', '#ffffff61'],
  yellow: ['#cabb0f', '#dccd0e', '#ffffff61'],
};

export default ReviewDeckColors;
